module.exports = __webpack_public_path__ + "img/logo.d9cc5f9c.png";